import {Component, EventEmitter, Input, LOCALE_ID, Output} from '@angular/core';
import { ClrCommonFormsModule, ClrDatepickerModule, ClrIconModule } from "@clr/angular";
import { DatePipe, JsonPipe, NgIf } from "@angular/common";
import { OrdersStoreService } from "../../../../_shared/services";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";

import { environment as env } from "../../../../../environments/environment";
import {ClarityIcons, exclamationCircleIcon, floppyIcon} from "@cds/core/icon";

@Component({
  selector: 'app-order-details-edit-position',
  standalone: true,
  imports: [
    ClrCommonFormsModule,
    NgIf,
    ClrDatepickerModule,
    ClrIconModule,
    DatePipe,
    ReactiveFormsModule,
    JsonPipe
  ],
  templateUrl: './order-details-edit-position.component.html',
  styleUrl: './order-details-edit-position.component.sass',
  providers: [{ provide: LOCALE_ID, useValue: 'de' }]
})
export class OrderDetailsEditPositionComponent {
  public editOrdersForm!: FormGroup;
  positions: any; // PositionsList[] = [];
  loading: boolean = false;

  @Input() projectId: string = '';
  @Input() jobId: number = 0;
  @Input() orderId: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Input() offerNr: string = '';
  @Input() orderStatus: string = '';
  @Output() updatedPosition = new EventEmitter();

  devMode: boolean;

  constructor(
    private orderss: OrdersStoreService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon)
  }

  ngOnInit() {
    this.loadOrdersPosition(this.projectId, this.orderId, this.jobId, this.editPosition, this.editPart);
  }

  initForm() {
    if (this.editOrdersForm) {
      return;
    }

    this.editOrdersForm = this.fb.group({
      project_number: [this.projectId],
      orderid: [this.orderId],
      position: [this.editPosition],
      part: [this.editPart],
      name: [this.positions[0].name],
      technical_drawing: [this.positions[0].technical_drawing],
      ordercid: [this.positions[0].ordercid],
      order_subject:  [this.positions[0].order_subject],
      companyname: [this.positions[0].companyname],
      material: [this.positions[0].material],
      weight: [this.positions[0].weight],
      description: [this.positions[0].description],
      remarks:  [this.positions[0].remarks],
      side_agreements: [this.positions[0].side_agreements],
      budget:  [this.positions[0].budget],
      delivery_date:  this.datePipe.transform(this.positions[0].delivery_date, 'dd.MM.yyyy'),
      status:  [this.positions[0].status],
      number_of_pieces: [this.positions[0].number_of_pieces],
      technology: [this.positions[0].technology],
      serial_nr: [this.positions[0].serial_nr],
      controlling_nr: [this.positions[0].controlling_nr],
      heat_nr: [this.positions[0].heat_nr],
      taric: [this.positions[0].taric],
      job_id: [this.jobId],
      comment_phm: [this.positions[0].comment_phm],
      specification: [this.positions[0].specification],
    });
  }

  loadOrdersPosition(projectId: string, requestId: number, jobId: number, positionId: number, partId: number) {
    const position = positionId.toString();
    const part = partId.toString();
    this.orderss.getOrdersPositions(projectId, requestId, jobId, position, part).subscribe({
      next: data => {
        this.positions = data.object;
      },
      complete: () => {
        this.initForm();
      },
      error: () => {
        return
      }
    });
  }

  updateOrdersPosition() {
    this.orderss.updateOrdersPosition(this.editOrdersForm.value)
      .subscribe({
        next: () => {
          this.updatedPosition.emit(true);
        },
        error: () => {
          return
        }
      });
  }

  cancelEdit() {
    this.updatedPosition.emit(true);
  }
}
